module.exports = __webpack_public_path__ + "static/media/6530.df6187a6.jpg";